<template>
    <div>
        

            <div class="Scroll">
            
            <b-list-group-item href="#" class="flex-column align-items-start" v-for="item in filteredAnniversaryNext" :key="item.id">
                <div class="d-flex w-100 justify-content-between">
                    <div class="pt-3 mr-3">
                        <div class="avatar">
                            <img :src="item.avatar && item.avatar != '' ? (item.avatar.indexOf('/') > 0 ? '' : $store.state.currentUser.remotePath + $store.state.currentUser.avatarPath ) + item.avatar : 'img/noimage.png'" class="circle-img" :title="item.name">
                            <span class="avatar-status bg-success" v-if="item.online===true"></span>
                        </div>
                    </div>
                    
                       <div class="w-100">
                            <div class="text-muted"><small>{{ item.name }}</small></div>
                            <div class="font-weight-bold">{{ item.alias }}</div>
                            <div class="small text-muted text-truncate">{{ item.department }}{{ item.jobname }}</div>
                            
                        </div>
                    
                    <div class="float-right font-weight-bold mt-1 text-primary">{{ item.birth }}</div>
                </div>
        
               
            </b-list-group-item>

            </div>
    
    </div>
</template>

<script>
import axios from "axios";

let now = new Date();

export default {
    name: 'componentAnniversary',
    data: function() {
        return {
            anniversary: [
                /*
                {
                    "id": 3,
                    "name": "Robson Monteiro",
                    "alias": "Robson",
                    "online": false,
                    "date": "18/01",
                    "job": "Oficina",
                    "avatar": "bmwagulhasnegras/user/115_avatar.jpg",
                    "class": "bg-danger",
                    "important": false,
                    day: 18,
                    month: 1
                },
                {
                    id: 21312,
                    name: "Adriana da Silva",
                    alias: "Adriana",
                    date: "27/01",
                    job: "Administrativo",
                    "avatar": "bmwagulhasnegras/user/114_avatar.jpg",
                    class: "bg-warning",
                    important: false,
                    day: 27,
                    month: 1
                },
                {
                    "id": 2313,
                    "name": "José de Arimateia",
                    "alias": "José",
                    "online": false,
                    "date": "12/02",
                    "job": "Auxiliar de RH",
                    "avatar": "img/avatars/7.jpg",
                    "class": "bg-danger",
                    "important": false,
                    day: 12,
                    month: 2
                }
               */
            ]
        }
    },
    computed: {
        filteredAnniversaryNext() {
            try {
                return this.anniversary.filter(item => {
                    return item.day != now.getDate() || item.month != now.getMonth() + 1; 
                })
            }
            catch(e) {
                return this.anniversary;
            }
            
        }
    },
    methods: {
        async refreshData() {
            var s = this
            await axios.get(
                this.$store.state.ws_url + "/portal/anniversary?companyId=" + this.$store.state.config.companyId
            ).then(function(resp) {
                s.anniversary = resp.data.obj;
            }).catch(function(error) {
                console.log(error)
            })
        }
    },
    mounted: function(){
        this.refreshData();
    }
}
</script>

<style scoped>
.circle-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  overflow: hidden;  
}

.Scroll {
        max-height: 400px;
        overflow-y: scroll;
    }
</style>